import script from "./CompData.vue?vue&type=script&setup=true&lang=js"
export * from "./CompData.vue?vue&type=script&setup=true&lang=js"

import "./CompData.vue?vue&type=style&index=0&id=d915a1b6&lang=css"

const __exports__ = script;

export default __exports__